import Vue from "vue";
import { mapGetters } from "vuex";
import numeral from "numeral";

const Validation = {
  install(Vue, options) {
    Vue.mixin({
      methods: {
        _goSocial(url) {
          if (!url) return;
          window.open(url, "_self");
        },
        GoBack() {
          this.$router.go(-1);
        },
        setQuery(query) {
          this.$router.push(this.localePath({ query }));
        },
        mapQuery(query) {
          this.setQuery({ ...this.$route.query, ...query });
        },
        call() {
          this.$router.push(this.localePath({ name: "me-about" }));
          // window.open(`https://work.weixin.qq.com/kfid/kfc70aed6043ba5a53f?enc_scene=ENC3WbRuuDcq6c6S1kcuAbqKKfGZDKpVxXAqtf8LcthPgiuUu3KPNyHeCAsERqQ95AURE`)
        },
        isGuest(path = null) {
          if (this.$auth.loggedIn) return false;
          const redirect = path ?? this.$route.fullPath;

          // set redirect to auth redirect
          this.$auth.$storage.setUniversal("redirect", redirect);

          if (this.$loader) {
            this.$loader.error("請先登入");
          }

          this.$router.push(
            this.localePath({
              name: "auth-login",
              query: { redirect },
            })
          );
          return true;
        },
        handleErrorsMessage({ response }) {
          const { status, data } = response;

          if (status == 422 && data.errors) {
            const key = Object.keys(data.errors)[0];
            const message = data.errors[key];
            if (message.length) {
              this.$loader.error(message[0]);
            }
            // this.$toast.error(data.errors[key][0]);
          }
        },
        cdnImage(url, width = 320) {
          if (!url || typeof url !== 'string') return url || '';
          if (!url.startsWith('http')) return url;

          // Encode path segments so Chinese / reserved chars (&) work with CF Image Resizing
          let source = url;
          try {
            const parsed = new URL(url);
            parsed.pathname = parsed.pathname
              .split('/')
              .map((segment) => {
                if (!segment) return segment;
                try {
                  return encodeURIComponent(decodeURIComponent(segment));
                } catch (e) {
                  return encodeURIComponent(segment);
                }
              })
              .join('/');
            source = parsed.toString();
          } catch (e) {
            // keep original url
          }

          // Cloudflare Image Resizing proxy
          return `/cdn-cgi/image/width=${width},format=auto,fit=scale-down,quality=85/${source}`;
        },
      },
      computed: {
        inMpayMiniApp() {
          return this.$store?.getters["app/inMpayMiniApp"] || false;
        },
        isAlipayHK() {
          return this.$store?.getters["app/isAlipayHK"] || false;
        },
        langs() {
          return this.$store?.getters["app/lang"] || [];
        },
        locales() {
          return this.$store?.getters["app/locales"] || [];
        },
        countryCodeOptions() {
          return this.$store?.getters["app/country_codes"] || [];
        },
        defaultCountryCode() {
          const currentLocale = this.locales?.find((item) => item.code.toLowerCase() == this.$i18n?.locale?.toLowerCase());
          const preferred = currentLocale?.default_country_code;
          const hasPreferred = this.countryCodeOptions?.some(opt => opt.value === preferred);
          return hasPreferred ? preferred : (this.countryCodeOptions?.[0]?.value || '+853');
        },
        mytel() {
          return process.env.TEL;
        },
        currency() {
          const locale = this.langs.find((item) => item.locale == this.$i18n?.locale);
          return locale?.currency ?? process.env.CURRECNY;
        },
        current_lang() {
          return this.langs.find((item) => item.locale == this.$i18n?.locale) || null;
        },
        inMo() {
          return this.$i18n?.locale == "mo";
        },
        loggedInUser() {
          return this.$auth?.loggedIn ? this.$auth.user.data : {};
        },
        _my() {
          return this.loggedInUser;
        },
        inWeiXin() {                    
          const ua = process.server
            ? this.$root.context.req.headers['user-agent']
            : (typeof navigator !== 'undefined' ? navigator.userAgent : '');
          return ua.toLowerCase().match(/MicroMessenger/i) == "micromessenger";
        },
      },
      watch: {
        defaultCountryCode: {
          handler(val) {
            if (this.form && 'country_code' in this.form && !this.form.country_code) {
              this.form.country_code = val;
            }
          },
          immediate: true
        }
      },
      filters: {
        number_format(value, fixed) {
          const format = fixed ? fixed : process.env.CURRENCY_FORMAT
          let formated = numeral(value).format(format)

          const separator = formated.split('.')

          // 小數點
          let decimalSeparator = separator[1] || ''

          // 小數前的位數
          let decimal = separator[0] || ''
          // 刪除小數位數後的0

          if (decimalSeparator) {
            while (decimalSeparator.endsWith('0')) {
              decimalSeparator = decimalSeparator.slice(0, -1)
            }
          }


          if (decimalSeparator) {
            formated = `${decimal}.${decimalSeparator}`
          } else {
            formated = decimal
          }

          return formated;
        },
      },
    });
  },
};

Vue.use(Validation);
